import { render } from "./App.vue?vue&type=template&id=dba3c99c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dba3c99c&lang=scss"

import exportComponent from "/Users/phil/Sites/2022lovehate/vue-starter-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__